<template>
  <div class="widget">
    <div class="widget-content row">
      <div class="col-2">
        <button
          v-if="tabs[current]?.displayPreviousButton"
          :disabled="disabled"
          class="btn blockStyle btn-success prevBtn"
          @click="goPrevTab"
        >
          <FontAwesomeIcon icon="fa-light fa-chevron-left" />
          {{ $t("registration.prev") }}
        </button>
      </div>
      <div class="col-8 d-flex justify-content-center">
        <button
          v-for="button in buttons"
          :key="button.id"
          :class="'btn me-2 btn-' + button.color"
          @click="clickButton(button)"
        >
          {{ button.label }}
        </button>
      </div>
      <div class="col-2 d-flex justify-content-end">
        <button
          v-if="tabs[current]?.displayNextButton"
          @click="goNextTab"
          class="btn btn-success blockStyle nextBtn"
          :disabled="disabled"
        >
          {{ $t("registration.next") }}
          <FontAwesomeIcon icon="fa-light fa-chevron-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegistrationControlsComponent",
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    current: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    buttons: {
      type: Array,
      required: true,
    },
  },
  emitted: ["save", "next", "prev"],
  data() {
    return {
      index: 0,
      length: null,
    };
  },
  watch: {
    current() {
      this.init();
    },
    tabs() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setCurrent();
    },
    setCurrent() {
      this.index = Object.values(this.tabs).findIndex((tab) => tab.id === this.current);
      this.length = Object.keys(this.tabs).length;
    },

    goNextTab() {
      this.$emit("next");
    },

    goPrevTab() {
      this.$emit("prev");
    },

    save() {
      this.$emit("save", true);
    },

    clickButton(button) {
      this.$emit("clickButton", button);
    },
  },
};
</script>

<style lang="scss" scoped>
.quote {
  h6 {
    margin: 15px 0;
  }

  &__part {
    border-bottom: 1px dashed $m_color_6;
    margin-bottom: 15px;
    padding-bottom: 15px;
  }
}
</style>
